import React from 'react';
import { PlanogramAutomationProvider } from './context/PlanogramAutomation';
import PlanogramAutomationScreen from './planogram-screen';

const PlanogramAutomation = () => {
    return (
        <PlanogramAutomationProvider>
            <PlanogramAutomationScreen />
        </PlanogramAutomationProvider>
    );
};

export default PlanogramAutomation;
